import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './ChartsModal.css';

const ChartsModal = ({ isOpen, onClose, onLoadChart, onDeleteChart }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [charts, setCharts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { currentUser } = useAuth();

  const fetchCharts = useCallback(async () => {
    if (!currentUser) return;
    setLoading(true);
    setError('');
    try {
      const token = await currentUser.getIdToken();
      const response = await fetch(`${API_URL}/api/charts`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || 'Failed to fetch charts');
      }
      const data = await response.json();
      setCharts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [currentUser]);

  useEffect(() => {
    if (isOpen) {
      fetchCharts();
    }
  }, [isOpen, fetchCharts]);

  const handleDelete = async (e, chartId) => {
    e.stopPropagation();
    const wasDeleted = await onDeleteChart(chartId);
    if (wasDeleted) {
      fetchCharts();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-charts">
        <button className="modal-close-btn" onClick={onClose}>&times;</button>
        <h2>マイチャート</h2>
        {error && <p className="modal-error">{error}</p>}
        {loading ? (
          <p>読み込み中...</p>
        ) : (
          <div className="charts-list">
            {charts.length > 0 ? (
              charts.map(chart => (
                <div key={chart.id} className="chart-item" onClick={() => onLoadChart(chart)}>
                  <div className="chart-info">
                    <span className="chart-name">{chart.name}</span>
                    <span className="chart-date">
                      更新日: {new Date(chart.updatedAt).toLocaleString()}
                    </span>
                  </div>
                  <div className="chart-actions">
                    <button className="action-btn delete" onClick={(e) => handleDelete(e, chart.id)}>削除</button>
                  </div>
                </div>
              ))
            ) : (
              <p>保存されたチャートはありません。</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartsModal;
